import { gql, TypedDocumentNode } from "@apollo/client";

import {
  DeleteTeamMutation,
  DeleteTeamMutationVariables,
} from "./DeleteTeam.generated";

const DELETE_TEAM: TypedDocumentNode<
  DeleteTeamMutation,
  DeleteTeamMutationVariables
> = gql`
  mutation DeleteTeam($teamUuid: String!) {
    deleteTeam(teamUuid: $teamUuid) {
      ok
      message
    }
  }
`;

export default DELETE_TEAM;
